<script lang="ts">
	import type { FeedItemData } from '$lib/types/Feed';
	import { OvalEffect, DatoImage } from '@atoms';
	import EventLabels from './EventLabels.svelte';
	import GenreTags from './GenreTags.svelte';
	import { DateFormats, Theme } from '@tools';

	let {
		data,
		showDate = false,
		onclick
	}: { data?: FeedItemData; showDate?: boolean; onclick?: () => void } = $props();
	let ratio = $state(0);

	let hoverTrigger: HTMLElement | undefined = $state(undefined);
	let isLoaded = $state(!data?.poster?.responsiveImage);
</script>

<div class="container EventPoster">
	{#if data}
		<EventLabels status={data.status} transform={`translateY(${ratio * -100}%)`} />
		<a
			class="poster"
			class:loading={!isLoaded}
			class:missing={!data.poster?.responsiveImage}
			href={data.path}
			title={data.title}
			tabindex="-1"
			{onclick}
			bind:this={hoverTrigger}
		>
			<OvalEffect color={Theme.current?.secondary} bind:ratio {hoverTrigger} />
			{#if data.poster?.responsiveImage}
				<div class="image-container" style:transform={`scale(${1 + ratio * 0.1})`}>
					<DatoImage responsiveImage={data.poster.responsiveImage} bind:isLoaded />
				</div>
			{/if}
		</a>
		{#if showDate && (data.genres || (data.showings && data.showings.length > 0))}
			<div class="row">
				<div class="date">
					{#if data.showings && data.showings.length > 0}
						{DateFormats.dateWithWeekday(data.showings[0].date)}
						{#if data.showings.length > 1}
							+ flere
						{/if}
					{/if}
				</div>
				{#if data.genres}
					<div class="genres">
						<GenreTags data={data.genres} gap={' '} />
					</div>
				{/if}
			</div>
		{/if}
		<a class="title text:h4" href={data.path} {onclick}>{data.title}</a>

		{#if !showDate && data.genres}
			<div class="genres">
				<GenreTags data={data.genres} gap={' '} />
			</div>
		{/if}
	{:else}
		<div class="placeholder" aria-hidden="true">
			<div class="poster">
				<div class="poster"></div>
			</div>
			<div class="title text:h4">Lorem Ipsum Doler</div>
			<div class="genres">
				<span class="genre">#foo</span>
				<span class="genre">#bar</span>
			</div>
		</div>
	{/if}
</div>

<style lang="scss">
	.image-container {
		width: 100%;
		height: 100%;
	}

	.container {
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: stretch;
		flex: 1 0 0;
		min-width: 46vw;
		scroll-snap-align: start;

		@include md {
			flex: 1 1 46vw;
			min-width: 0;
			padding: 0;
		}
	}

	.poster {
		position: relative;
		overflow: hidden;
		aspect-ratio: 1 / #{$ratio1};
		background-color: rgba(0, 0, 0, 0.05);

		/* &.loading {
			@include animateLoading;
		} */

		&.missing {
			&::after {
				content: '';
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				height: 15%;
				width: 15%;
				background-repeat: no-repeat;
				background-size: contain;
				background-position: center center;
				background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='33' height='35.61' viewBox='0 0 33 35.61'%3E%3Cpath style='fill-rule: evenodd; fill: currentColor;' d='M0,28.89c0-3.76,4.74-6.72,10.78-6.72s10.78,3,10.78,6.72-4.74,6.72-10.78,6.72S0,32.65,0,28.89ZM33,13.28c0-3.53-2.31-4.38-4.4-5.13L18.26,4.41C15.21,3.3,11.47,2.15,10.86,0h-.08V4.94c0,3.64,2.22,4.34,4.4,5.13l10.34,3.74c3.15,1.14,6.8,2.26,7.4,4.41H33Zm0,9.84c0-3.53-2.31-4.38-4.4-5.13L18.26,14.25c-3.05-1.11-6.79-2.26-7.4-4.41h-.08v4.94c0,3.64,2.22,4.34,4.4,5.13l10.34,3.75c3.15,1.13,6.8,2.25,7.4,4.4H33Z' /%3E%3C/svg%0A%3E%0A");
				opacity: 0.1;
			}
		}
	}

	.image-container {
		position: relative;
		z-index: 1;
		height: 100%;
		width: 100%;
	}

	.title {
		display: -webkit-box;
		box-sizing: initial;
		line-height: 1.1em;
		max-height: 3.3em;
		white-space: normal;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 3;
		line-clamp: 3;
		overflow-wrap: break-word;
		word-wrap: break-word;
		hyphens: auto;
		margin-top: 0.75rem;
		margin-bottom: 0.5rem;
		text-decoration: none;
	}

	.row {
		display: flex;
		gap: 1em;
		justify-content: space-between;
		margin-top: 0.75rem;

		.date {
			flex: 1 0 auto;
		}

		.genres {
			flex: 0 1 auto;
			text-align: right;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;

			// overflow: hidden;
			// line-clamp: 1;
			// -webkit-line-clamp: 1;
			// -webkit-box-orient: vertical;
			// display: -webkit-box;
			// white-space: normal;
		}
	}

	.genres {
		text-transform: lowercase;
	}

	.placeholder {
		display: contents;

		.poster {
			@include animateLoading;
		}

		.title {
			height: 0.9em;
			margin-top: 0.3em;
			align-self: start;
			color: transparent;
			@include animateLoading;
		}

		.genre {
			height: 0.9em;
			margin-top: 0.3em;
			color: transparent;
			@include animateLoading;
		}
	}
</style>
